
namespace GeniuzPOS.Purchase {
    import fld = PoPurInvoiceRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PoPurInvoiceGrid extends Serenity.EntityGrid<PoPurInvoiceRow, any> {
        protected getColumnsKey() { return PoPurInvoiceColumns.columnsKey; }
        protected getDialogType() { return PoPurInvoiceDialog; }
        protected getIdProperty() { return PoPurInvoiceRow.idProperty; }
        protected getInsertPermission() { return PoPurInvoiceRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurInvoiceRow.localTextPrefix; }
        protected getService() { return PoPurInvoiceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

         
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PoPurInvoiceService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons
        }


        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-13));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };
            Q.first(filters, x => x.field == fld.CreateBy).init = w => {
                var userId = Authorization.userDefinition.Username;
                // console.log(Authorization.userDefinition.Username);
                // console.log(userId);
                (w as Serenity.LookupEditor).value = userId;
            };

            return filters;
        }
        protected getColumns() {
            var columns = super.getColumns();
    
            columns.splice(5, 0, {
                id: 'Print CountApprove',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-countapprove" title="countapprove">' +
                    '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });
    
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
    
            // if (e.isDefaultPrevented())
            //     return;
    
            var item = this.itemAt(row);
            var target = $(e.target);

            
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
    
            if (target.hasClass('inline-action')) {
                e.preventDefault();
    
                if (target.hasClass('print-countapprove')) {
                    this.view.getRows()
                    const request = this.getView().params as PoPurInvoicePrintData
                    request.SysDocNo = item.SysDocNo
                    request.Header = Q.tryFirst(PoPurInvoiceRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    if (fg != null) {
                        let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x=> x.ShopId == item.ShopId)
                        request.BizName = s.ShopRegName
                        request.BizAddressLine1 = s.ShopRegAddressLine1
                        request.BizAddressLine2 = s.ShopRegAddressLine2
                        request.BizAddressLine3 = s.ShopRegAddressLine3
                        request.TaxId = s.ShopTaxId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1)
                        request.BizName = q.BizName
                        request.BizAddressLine1 = q.TaxInvAddrLine1
                        request.BizAddressLine2 = q.TaxInvAddrLine2
                        request.BizAddressLine3 = q.TaxInvAddrLine3
                        request.TaxId = q.BizName
                    }
                    request.Supdata = Q.tryFirst(Supplier.CsSupplierRow.getLookup().items, x=> x.SupplId == item.SupplierId)
                    let x =  Q.tryFirst(Lookups.VwPaytermCodeLookupRow.getLookup().items, x=> x.PayTermCode == item.PayTermCode);
                    if(x !=null){
                            request.payment = x.CreditTerm.toString() ;
                        }else {
                            request.payment = ''
                        }
                        let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)

                        if(p != null){
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Purchase/PoPurInvoice","")
                            request.URLpic = ap + "/upload/" +  p.ShopLogoOnFrontScreen
                        }else{
                            request.URLpic = "https://" + window.location.host + "/upload/info.jpg"
                        }

                         let o = item.PayTermCode
                    if(!Q.isEmptyOrNull(o)){
                        request.Paydesc = Q.tryFirst(Lookups.VwPaytermCodeLookupRow.getLookup().items, x=> x.PayTermCode == item.PayTermCode).PayTermDesc
                    }else {
                        request.Paydesc = ''
                    }
                        // console.log(window.location.host + "/upload/info.jpg")
                        // console.log(this.getService())
                    //request.Details = (PoPurInvoiceDtRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    // const getPO = Q.first(PoPurInvoiceRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo);
                    
                    console.log(request)

                    var fgApp = 0;
                    let lookupconsignfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 33 && x.SysFg > 0)          
                    if (lookupconsignfg != null) {
                          let c = item.ApproveFg;
                          if(c == 1){
                            fgApp = 0;
                          }else{
                            fgApp = 1;
                          }                       
                    } 

                    if(fgApp == 0){

                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                    }else{
                        Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                    }

                    
                    ;
                }
            }
        }

        

        
    }
    
    
}